import React from 'react'
import BrowserLink from '../../../../../components/BrowserLink'
import * as cl from './PremiumButton.module.css'

const PremiumButton = ({link = '#'}) => {
  return (
    <BrowserLink href={link} className={cl.link} >
      premium
    </BrowserLink>
  )
}

export default PremiumButton